import { render, staticRenderFns } from "./ManufacturerModelSelector.vue?vue&type=template&id=87b08f7c"
import script from "./ManufacturerModelSelector.vue?vue&type=script&lang=js"
export * from "./ManufacturerModelSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports